import { z } from 'zod';
import type { JobHistoryItemType } from './types';

export class JobHistoryUtils {
    static extractAllValues(diffData: any): JobHistoryItemType[] {
        let results: JobHistoryItemType[] = [];
        for (const key of Object.keys(diffData)) {
            results = results.concat(this.extractOldAndNewValues(diffData, key));
        }
        return results;
    }

    static extractOldAndNewValues(diffData: any, key: string): JobHistoryItemType[] {
        try {
            z.record(
                z.string(),
                z.object({
                    old: z.any(),
                    new: z.any(),
                })
            ).parse(diffData);
        } catch (e) {
            console.error('job_history, error', e);
            return [];
        }
        let results = [];
        let old = diffData[key]?.old ?? {};
        let newV = diffData[key]?.new ?? {};
        if (typeof old === 'object' && typeof newV === 'object') {
            for (const k of Object.keys(Object.assign({}, newV, old))) {
                if (old[k] == newV[k]) {
                    continue;
                }
                results.push({
                    old: old[k] ?? null,
                    new: newV[k] ?? null,
                    id: key + '.' + k,
                });
            }
        } else {
            results.push({ old, new: newV, id: key });
        }
        this.clearOldAndNewValues(results);
        return results;
    }

    static clearOldAndNewValues(results: JobHistoryItemType[]) {
        results.forEach(r => {
            if (
                r.old === null ||
                r.old === undefined ||
                (typeof r.old === 'object' && Object.keys(r.old).length === 0)
            ) {
                r.old = null;
            }
            if (
                r.new === null ||
                r.new === undefined ||
                (typeof r.new === 'object' && Object.keys(r.new).length === 0)
            ) {
                r.new = null;
            }
        });
    }
}
